import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import isString from "lodash/isString";
import { defineComponent as _defineComponent } from 'vue';
import isUrl from 'is-url';
import { setJumpToTopWindow } from '@/shared/util';
import { nextTick, ref, watch } from 'vue';
/**
 * 使用iframe加载HTML的沙箱环境，不使用srcdoc是因为iOS下存在兼容性问题
 */ export default /*#__PURE__*/ _defineComponent({
    __name: 'sandbox',
    props: {
        type: {
            validator: function(val) {
                return [
                    'HTML',
                    'URL',
                    'PDF_URL'
                ].indexOf(val) > -1;
            },
            default: 'HTML'
        },
        content: {
            type: String,
            default: ''
        },
        proxy: {
            type: Boolean,
            default: true
        },
        openToTop: {
            type: Boolean,
            default: false
        },
        heightAuto: {
            type: Boolean,
            default: false
        },
        lazy: {
            type: Boolean,
            default: false
        }
    },
    setup: function(__props) {
        var props = __props;
        function createPDFReaderURL(url, proxy) {
            return "".concat(process.env.VUE_APP_PREFIX, "pdf-mobile-viewer/?url=").concat(encodeURIComponent("".concat(process.env.VUE_APP_PREFIX, "api/v1/diversion/agreement/show?needProxy=").concat(proxy !== null && proxy !== void 0 ? proxy : true, "&value=").concat(url)));
        }
        // iframe创建时history.length
        var startHistoryLength = ref(null);
        var container = ref(null);
        var viewer;
        var createViewer = function(value) {
            if (!container.value) {
                nextTick(function() {
                    createViewer(value);
                });
                return;
            }
            // 记录iframe创建时history.length
            startHistoryLength.value = window.history.length;
            viewer = document.createElement('iframe');
            if (props.openToTop) {
                viewer.onload = function() {
                    if (viewer) {
                        setJumpToTopWindow(viewer);
                    }
                };
            }
            if (props.heightAuto) {
                viewer.onload = function() {
                    if (viewer) {
                        var _viewer_contentWindow;
                        setIframeHeight(viewer);
                        var innerDoc = (_viewer_contentWindow = viewer.contentWindow) === null || _viewer_contentWindow === void 0 ? void 0 : _viewer_contentWindow.document;
                        if (innerDoc === null || innerDoc === void 0 ? void 0 : innerDoc.body) {
                            innerDoc.body.style.overflow = 'hidden';
                        }
                    }
                };
            }
            container.value.appendChild(viewer);
            if (props.type === 'PDF_URL') {
                viewer.src = createPDFReaderURL(value, props.proxy);
            } else if (isUrl(value) || props.type === 'URL') {
                viewer.src = value;
            } else {
                var doc = viewer.contentDocument;
                doc === null || doc === void 0 ? void 0 : doc.write(value);
                // 必须手动关闭，否则iOS中的WKWebView在完成HTML加载后会等待一段时间才关闭
                doc === null || doc === void 0 ? void 0 : doc.close();
            }
        };
        var setIframeHeight = function(iframe) {
            var doc = iframe.contentWindow.document;
            var height = doc.body.scrollHeight || doc.documentElement.scrollHeight;
            iframe.style.height = height + 'px';
        };
        var destoryViewer = function() {
            if (!container.value) {
                nextTick(function() {
                    destoryViewer();
                });
                return;
            }
            if (viewer) {
                if (props.openToTop) {
                    viewer.onload = null;
                }
                container.value.removeChild(viewer);
                viewer = null;
                // iframe销毁时history.length
                var endHistoryLength = window.history.length;
                // 判断iframe内是否有过跳转，如果发生过跳转，则将当前的histroy退回到创建iframe之前
                if (startHistoryLength.value != null && endHistoryLength > startHistoryLength.value) {
                    window.history.go(-(endHistoryLength - startHistoryLength.value));
                }
                startHistoryLength.value = null;
            }
        };
        watch(function() {
            return props.content;
        }, function(val) {
            destoryViewer();
            if (isString(val) && val.length > 0 && val !== 'about:blank') {
                if (props.lazy) {
                    nextTick(function() {
                        createViewer(val);
                    });
                } else {
                    createViewer(val);
                }
            }
        }, {
            immediate: true
        });
        return {
            __sfc: true,
            createPDFReaderURL: createPDFReaderURL,
            props: props,
            startHistoryLength: startHistoryLength,
            container: container,
            viewer: viewer,
            createViewer: createViewer,
            setIframeHeight: setIframeHeight,
            destoryViewer: destoryViewer
        };
    }
});
